export default __webpack_public_path__ + "static/media/ankr-logo.c398d9db.svg";